"use strict";

module.exports = function () {
  return this.opts.childRow || this.$scopedSlots.child_row;
};


// WEBPACK FOOTER //
// ./src/components/vuetable-2-kernel/compiled/computed/has-child-row.js